export default __webpack_public_path__ + "static/media/nifty500Momentum.e2491e42.png";